import React, { useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT } from "../data/site";

const Block = ({ label, children }) => (
  <div className="mb-8">
    <div className="kicker mb-3">{label}</div>
    <div className="text-[15px] leading-relaxed text-[var(--ink-soft)]">{children}</div>
  </div>
);

export default function Impressum() {
  const { t } = useLang();
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <main className="pt-32 md:pt-40 pb-24 relative z-10" data-testid="impressum-page">
      <div className="container-x max-w-3xl">
        <div className="kicker mb-5">Legal</div>
        <h1 className="display text-5xl md:text-7xl mb-3">{t.impressum.title}</h1>
        <p className="font-serif italic text-[var(--terracotta)] text-lg mb-12">{t.impressum.sub}</p>

        <Block label={t.impressum.ownerLabel}>
          <p className="text-[var(--ink)] text-lg">{CONTACT.name}</p>
          <p>{CONTACT.street}</p>
          <p>{CONTACT.zip} {CONTACT.city}, {CONTACT.country}</p>
        </Block>

        <Block label={t.impressum.contactLabel}>
          <p>Tel: <a href={`tel:${CONTACT.phoneLink}`}>{CONTACT.phone}</a></p>
          <p>E-Mail: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></p>
          <p>Web: lotussutra.at</p>
        </Block>

        <Block label={t.impressum.profLabel}>
          <p className="text-[var(--ink)]">{t.impressum.profValue}</p>
          <p>{t.impressum.profCountry}</p>
        </Block>

        <Block label={t.impressum.mittLabel}>
          <p>{t.impressum.mittText}</p>
        </Block>

        <Block label={t.impressum.copyLabel}>
          <p>{t.impressum.copyText}</p>
        </Block>

        <Block label={t.impressum.disclaimerLabel}>
          <p>{t.impressum.disclaimerText}</p>
        </Block>
      </div>
    </main>
  );
}
